import React from "react";
import { Link } from "react-router-dom";
import ProductPage from "../../components/ProductPages/ProductPage";
import { PRODUCT_SCREENSHOTS } from "../../components/ProductPages/productScreenshots";
import { aiAssistStep } from "../../utility/aiAssistCopy";

const sections = [
  {
    title: "Bowlers pick their own squad",
    body: "Bowlers choose their squad and events online. Their information goes onto your roster for you to review. You are not writing names from a napkin waitlist.",
  },
  {
    title: "When a spot opens, promote the waitlist",
    body: "When a spot opens, the next eligible team on the waitlist can be promoted. You do not call down a list of people who may already have left.",
  },
  {
    title: "A 24-hour hold while they finish",
    body: "A 24-hour cart hold gives bowlers time to complete their signup. You can see who is held and who still owes without chasing texts.",
  },
  {
    title: "Bowlers check their own entries",
    body: "My Signups shows bowlers their entries, holds, and cancellations so they do not call the desk for every status question.",
  },
];

const BowlingTournamentSignups = () => (
  <ProductPage
    title="Bowling Tournament Signups | Bowling Tournament App"
    description="Stop filling squads from phone calls and napkin waitlists. Bowlers choose their squad and events online. You review the roster in one place."
    keywords={[
      "bowling tournament signups",
      "bowling tournament registration",
      "online bowling tournament signup",
      "bowling tournament waitlist",
    ]}
    canonicalUrl="/bowling-tournament-signups"
    heading="Stop filling squads from phone calls and napkins"
    lede="Bowlers choose their squad and events online. You review the roster. Waitlists promote when a spot opens."
    analyticsLocation="bowling_tournament_signups"
    secondaryTo="/bowling-tournament-card-payments"
    secondaryLabel="Card payments"
    sectionHeading="Online registration for every squad"
    sections={sections}
    screenshot={PRODUCT_SCREENSHOTS.signups}
    importStep={aiAssistStep("signups")}
  >
    <p className="mt-12 text-brand-muted text-base leading-relaxed max-w-3xl">
      Turn on Pay now when you want bowlers to pay by card. See{" "}
      <Link
        to="/bowling-tournament-card-payments"
        className="text-brand-charcoal hover:underline"
      >
        Card payments
      </Link>
      .
    </p>
  </ProductPage>
);

export default BowlingTournamentSignups;
